import MobileDeveloperPage from "./MobileDeveloperPage";

export default function KotlinDeveloperPage() {
  return <MobileDeveloperPage technology="kotlin" />;
}
